<template>
  <v-app>
    <v-main class="accent-2 primary" app>
      <app-bar/>
      <v-row v-if="!applicationStore.migrationNoticeWasDismissed">
        <v-col cols="12" md="6" offset-md="3" class="mt-md-5">
          <v-alert closable @click:close="applicationStore.migrationNoticeWasDismissed = true">
            Vi har opplevd tekniske problemer, og har derfor måtte lansere en beta-versjon av V2 før den var helt klar.
            Derfor håper vi at de mest nødvendige funksjonene du leter etter i dag fungerer som de skal.
          </v-alert>
        </v-col>
        <meta name="robots" content="noindex">
      </v-row>
      <default-view/>
    </v-main>
    <v-divider class="mt-10 mt-md-0"/>
    <v-footer color="transparent">
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <div class="px-4 py-2 text-center w-100">
            2020-{{ new Date().getFullYear() }} — <strong>{{ $t('app.name') }}</strong>
            &copy;
            <a aria-description="Open OneCode.no in a new tab"
               href="https://onecode.no?utm_source=snuspris.no&utm_campaign=footer"
               class="text-black"
               rel="nofollow"
               target="_blank"
            >
              OneCode.no
              <v-icon size="xx-small">mdi-open-in-new</v-icon>
            </a>
            <small>{{APP_VERSION}}</small>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="px-4 py-2 text-center w-100">
            <router-link :to="RouteName.website.legal.privacy" rel="nofollow" class="text-black">
              {{$t('navigation.privacy')}}
            </router-link>
            |
            <router-link :to="RouteName.website.legal.terms" rel="nofollow" class="text-black">
              {{$t('navigation.terms')}}
            </router-link>
          </div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>
<script setup lang="ts">
import AppBar from "@/layouts/default/app-bar.vue";
import DefaultView from '@/layouts/default/view.vue'
import {useApplicationStore} from "@/store/application";
import {APP_VERSION, RouteName} from "@/keys";

const applicationStore = useApplicationStore();

</script>
